import { useState } from 'react';
import { toast } from 'sonner';
import axios from 'axios';

// API Configuration - use environment variable or fallback to current origin
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (typeof window !== 'undefined' ? window.location.origin : '');
const API = `${BACKEND_URL}/api`;

const initialFormState = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  subject: '',
  message: ''
};

export const useContactForm = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormState);
  const [isRobot, setIsRobot] = useState(true);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const sendEmail = async (data) => {
    // Call backend API to send email
    const response = await axios.post(`${API}/contact`, {
      first_name: data.firstName,
      last_name: data.lastName,
      email: data.email,
      phone: data.phone,
      subject: data.subject,
      message: data.message
    });
    
    return response.data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (isRobot) {
      toast.error("Verification Required", {
        description: "Please confirm you're not a robot.",
        duration: 5000,
      });
      return;
    }
    
    setLoading(true);
    
    try {
      // Submit form to backend and send email
      await sendEmail(formData);
      
      toast.success("Message Sent Successfully!", {
        description: "Thank you for reaching out. We'll get back to you within 24 hours.",
        duration: 5000,
      });
      
      // Reset form
      setFormData(initialFormState);
      setIsRobot(true);
    } catch (error) {
      console.error('Contact form error:', error);
      toast.error("Error", {
        description: "Failed to send message. Please try again.",
        duration: 5000,
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    isRobot,
    setIsRobot,
    handleChange,
    handleSubmit
  };
};
